import React, { useContext } from "react"
import BannerContext from "../lib/context"

import Helmet from "react-helmet"

import Header from "../components/Header"
import { TextSection } from '../components/Section'
import BannerSection from "../components/BannerSection"

import ChildrenImage from '../assets/images/home/children.jpg'
import YouthMinistry from '../assets/images/stock-photos/youth-ministry.jpg'


import YoungAdultImage from '../assets/images/groups/Youth-Groups.jpg'

import Fireplace from '../assets/images/church/mens-group.jpg'
import Emerge from '../assets/images/church/womens-group.jpg'

// import LifeImage from '../assets/images/home/life-groups2.jpg'
import LifeImage from '../assets/images/groups/Homegroups.jpg'
import DinnerParty from "../assets/images/church/dinner-party.jpg"
import InternationalDay from "../assets/images/church/international-day.jpg"
import BBQ from "../assets/images/church/bbq.jpg"
import YouthGirls from "../assets/images/church/youth-girls.jpg"


const Homepage = () => {

    // const [ headerData, setHeaderData ] = useState( [ ] )
    const siteTitle = "Blackheath and Charlton Baptist Church - Church Life"
    // const pageData = useLocalData( getStaticPageData, 'church-life-banners', 'church-life-banners' )
    const pageData = useContext( BannerContext )[ 'church-life-banners' ]
    const { header, banners } = pageData || { header: null, banners: null }
    const headerImages = header ? header.images : []
    const headerTitle = header ? header.title : 'Church Life'
    // const headerImages = useData( getEventsHeader )
    // const headerTitle = "Church Life"
    const headerIcon = <span className="icon major"><i className="fas fa-heartbeat"></i></span>

    return (

        <div id='church-life-page'>
            <Header images={[ InternationalDay, BBQ, DinnerParty ]} headerTitle={headerTitle} tint={0.3} />
            <Helmet title={siteTitle} />

            <TextSection 
                id="life-groups" 
                title="Life Groups"
                description="Our Life Groups meet at various times throughout the week, providing a smaller, more intimate environment for individuals to share, disciple and grow together in the Word, prayer and fellowship.
                Members support and care for one another through life's celebrations, surprises and challenges. 
                We encourage everyone in our church family to be join a Life Group to build deeper relationships and walk alongside each other on our faith journey."
                buttons={[ { url: "/lifegroups", text: "Join Group",  style: 'transparent-button' } ]}
                background={[ LifeImage ]}
                tint={0.5}
                blur={0.3}
            />

            <TextSection 
                id="prayer-meetings" 
                title="Prayer Meetings"
                style="blue"
                description={`
                    <b>Monday - Friday from 6:00am  </b>

                    Join us for our Wednesday Prayer and Fasting Service online at 6:00p.m- 7:00pm. During the service, we break the fast with communion.

                    <small>"And let us consider how we may spur one another on toward love and good deeds, not giving up meeting together, as some are in the habit of doing, but encouraging one another—and all the more as you see the Day approaching."   
                            Hebrews 10:24-25 NIV"</small>`}
                // buttons={[ { url: "/prayer-meetings", text: "Read More" } ]}
                // background={[ PrayerMeetingImage ]}   
                // tint={0.35}
                // opacity={0.2}
                buttons={[ { url: "/media/audio", text: "Audio Recordings",  style: 'special' } ]}
                // extraCSS={{backgroundColor: 'rgba(0, 55, 100, 0.1)'}}
            />


            <TextSection 
                id="childrens-church" 
                title="B.L.A.S.T - (Being Light and Salt)"
                description={`Our Children’s Church ministry provides children the opportunity to learn about Christ and scripture, through practical and interactive activities and conversations. 
                    We believe that creative learning enhances their ability to learn about God and engage with His Word.

Throughout the year we offer a variety of activities that allow children to connect with the wider church family through specific areas of interest  
to them. Our children’s ministry leaders have all undergone safeguarding training and are committed to prioritising the children’s safety and welfare. `
                }
                style="style2"
                // buttons={[ { url: "/childrens-church", text: "Read More" } ]}
                background={[ ChildrenImage ]}
                alt
                tint={0.7}
                opacity={0.71}
            />

            <TextSection 
                id="youth-ministry" 
                title="IGNITE - Youth Ministry"
                description={`Our Youth Ministry offers a dynamic space for teens to grow in faith and fellowship through dedicated youth services and activities.`}
                style="style2"
                // buttons={[ { url: "/childrens-church", text: "Read More" } ]}
                background={[ YouthMinistry ]}
                alt
                tint={0.7}
                opacity={0.71}
            />

            <TextSection 
                id="young-adults"
                title="Young Adults Ministry"
                description={ `Our Young Adults’ Ministry serves those aged 18 to 35. 
                    The aim of this ministry is to disciple, nurture and equip our young adults to become fruitful Christians whose lives bear witness to the testimony of Jesus Christ. 
                    We encourage and nurture them to live lives that demonstrate the fruits of the Holy Spirit.
 
By grounding them in scripture, our young adults are pastored and equipped to live as intelligent, diligent and successful members and leaders of society.`}
                style="style1 large blue"
                // background={[ YoungAdultImage ]}
                tint={0.7}
                blur={0.3}
            />


            <TextSection 
                id="vertical-youth-club" 
                title="Vertical Youth Club"
                description={`Every Tuesday during term time, from 6:00 pm to 7:00 pm, children and youth gather to play games, socialise, and build lasting friendships.`}
                style="style2"
                // buttons={[ { url: "/childrens-church", text: "Read More" } ]}
                background={[ YouthGirls ]}
                alt
                tint={0.5}
                opacity={0.8}
            />


            <TextSection 
                id="emerge"
                title="Emerge (Equipped to Thrive)"
                description={ `Emerge Ministry is our vibrant women’s group committed to supporting one another through continuous prayer partnerships. 
                    We foster spiritual growth and community through various events throughout the year, including conferences, retreats, themed dinners, lunches, and breakfasts. 
                    Join us as we nurture our faith, build lasting friendships, and celebrate together in fellowship`}
                style="style1"
                background={[ Emerge ]}
                tint={0.19}
                blur={0.1}
                opacity={0.18}
                alt
            />

            <TextSection 
                id="fireplace-ministry"
                title="Fireplace Ministry"
                description={ `The Fireplace Ministry is a dedicated men’s group that meets regularly for prayer, fellowship, and engaging activities such as golf.
                    In addition to spiritual growth and camaraderie, the ministry actively serves the church by helping maintain the grounds and ensuring the space remains welcoming for all.`}
                style="style1"
                background={[ Fireplace ]}
                tint={0.7}
                opacity={0.8}
                blur={0.02}
            />

        

            <BannerSection banners={banners} />


        </div>
    )
}

export default Homepage